import _groupBy from 'lodash.groupby';
import DashboardListItem from './DashboardListItem';
import EmptyList from '@/components/Common/EmptyList';
import ProgressBar from '../../ProgressBar';

// @vue/component
export default {
  name: 'DashboardListForConnections',

  components: {
    DashboardListItem,
    EmptyList,
    ProgressBar,
  },
  props: {
    connectionList: {
      type: Array,
      default: () => [],
    },
    connectionTypeList: {
      type: Array,
      default: () => [],
    },
    projects: {
      type: Array,
      default: () => [],
    },
    projectList: {
      type: Array,
      default: () => [],
    },
    agentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentWiretappingUuid: null,
      isStopTimer: false,
      connectionWithOpenSurvey: null,
    };
  },
  computed: {
    isTakingNewData() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'dashboard/getLiveList',
      ]);
    },
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'connections/types/getTypeList', 'dashboard/steps/getStepList', 'dashboard/liveList',
      ]);
    },
    connectionStepList() {
      return _groupBy(this.$store.getters['connections/steps/list'].records, 'step_name');
    },
    connectionStatusList() {
      return _groupBy(this.$store.getters['connections/statuses/list'].records, 'type');
    },
  },

  async created() {
    await this.$store.dispatch('connections/statuses/getStatusList');
    await this.$store.dispatch('connections/steps/getStepList');
  },

  mounted() {
    this.$EventBus.$on('MakeCallPopover/IS_ANY_CALLING_RECORD', () => {
      this.fetchConnections();
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('MakeCallPopover/IS_ANY_CALLING_RECORD');
  },

  methods: {
    fetchConnections() {
      if (!this.isStopTimer) {
        this.$store.dispatch('dashboard/getLiveList');
      }
    },
    setWiretappingUuid(uuid) {
      this.currentWiretappingUuid = uuid;
    },
    isAnyPopoverActive(value) {
      this.isStopTimer = value;
    },
  },
};
